export default __webpack_public_path__ + "static/blob2-9dea51b934e30a2b18b78b16d9bdeb40.svg";